import { render, staticRenderFns } from "./WorkOrderParticipatorStatusTag.vue?vue&type=template&id=f08d8380&scoped=true&"
import script from "./WorkOrderParticipatorStatusTag.vue?vue&type=script&lang=ts&"
export * from "./WorkOrderParticipatorStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08d8380",
  null
  
)

export default component.exports